// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__fQXwM","image":"Header_image__u3GGj","name":"Header_name__1Gwzj","info":"Header_info__r_tEM","infoRow":"Header_infoRow__1iJBz"};